export default __webpack_public_path__ + "static/media/nature.a32253c8.png";